import script from "./NvBar.vue?vue&type=script&setup=true&lang=js"
export * from "./NvBar.vue?vue&type=script&setup=true&lang=js"

import "./NvBar.vue?vue&type=style&index=0&id=535c7183&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-535c7183"]])

export default __exports__